module.exports = __webpack_public_path__ + "static/media/31.ef944b59.jpg";